import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import { reduxForm, initialize, Field, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import moment from 'moment';
import { submitNewClientForm } from 'redux/modules/teamManagement';
import { LeftNavLayout } from 'containers';
import { LLTextField, LLDropDownList } from 'components/FormElements';
import { GrayButton, ModalTopBar, NewClientForm, PageHeader } from 'components';
import * as styles from './ClientNew.scss';
import { getOrgProducts } from 'redux/modules/teamManagement';
var ClientNew = (_dec = reduxForm({
  form: 'newClient'
}), _dec2 = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  initialize: initialize,
  submitNewClientForm: submitNewClientForm,
  getOrgProducts: getOrgProducts
}), _dec(_class = _dec2(_class = /*#__PURE__*/function (_Component) {
  _inherits(ClientNew, _Component);

  var _super = _createSuper(ClientNew);

  function ClientNew(props) {
    var _this;

    _classCallCheck(this, ClientNew);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (values) {
      var data = {
        contract: {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          businessName: values.businessName,
          phone: values.phone
        },
        address: {
          address1: values.address1,
          address2: values.address2,
          region: values.region,
          postcode: values.postcode,
          locality: values.locality
        },
        // user: {
        //   firstName: values.firstName,
        //   lastName: values.lastName,
        //   email: values.email
        // },
        productId: 5
      };

      if (values.businessName && values.buinessName !== '') {
        _this.props.submitNewClientForm(_this.props.theme.org, data).then(browserHistory.push('/global/clients'));
      } else {
        alert('You need to enter a Business Name.');
      }
    });

    _this.state = {
      selectedTab: 0
    };
    return _this;
  }

  _createClass(ClientNew, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getOrgProducts(this.props.theme.org);
    }
    /** *******************************************************************************************
     HANDLER METHODS
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          paddingBottom: 36
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "New Client"
      }), /*#__PURE__*/React.createElement(ModalTopBar, {
        backUrl: "/global/clients",
        showCloseBtn: false,
        style: {
          position: 'static',
          marginBottom: 24
        },
        backLabel: "View All Clients"
      }), /*#__PURE__*/React.createElement(PageHeader, {
        primary: "New Client",
        style: {
          paddingLeft: 36
        }
      }), /*#__PURE__*/React.createElement(NewClientForm, {
        onSubmit: this.handleSubmit,
        styles: styles
      }));
    }
  }]);

  return ClientNew;
}(Component)) || _class) || _class);
export default ClientNew;